import { render } from "./InvitationHeader.vue?vue&type=template&id=9410a42e&scoped=true"
import script from "./InvitationHeader.vue?vue&type=script&lang=js"
export * from "./InvitationHeader.vue?vue&type=script&lang=js"

import "./InvitationHeader.vue?vue&type=style&index=0&id=9410a42e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9410a42e"]])

export default __exports__